<template>
    <div>
        <div class='pageBottom'>
            &nbsp;&nbsp;&nbsp;我是有底线的&nbsp;&nbsp;&nbsp;
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return {

        };
    },
    methods: {

    }
};
</script>
<style lang="scss" scoped>
.pageBottom{
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    margin: 8px 0;
    color: #e3e2e2;
    font-size: 12px;
    line-height: 20px;
    border-color: #e3e2e2;
    border-style: solid;
    border-width: 0;
    padding:0 12px;
}
.pageBottom::before{
    display: block;
    content: '';
    transform: scaleY(0.5);
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    box-sizing: border-box;
    height: 1px;
    border-color: inherit;
    border-style: inherit;
    border-width: 1px 0 0;
}
.pageBottom::after{
    display: block;
    content: '';
    transform: scaleY(0.5);
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    box-sizing: border-box;
    height: 1px;
    border-color: inherit;
    border-style: inherit;
    border-width: 1px 0 0;
}
</style>
